import { render } from "./ModernContact.vue?vue&type=template&id=1898d348&scoped=true"
import script from "./ModernContact.vue?vue&type=script&lang=js"
export * from "./ModernContact.vue?vue&type=script&lang=js"

import "./ModernContact.vue?vue&type=style&index=0&id=1898d348&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1898d348"]])

export default __exports__